import { cva } from 'class-variance-authority'

// Styles for the SwitchPrimitives.Root
export const rootStyles = cva(
  `
    peer
    inline-flex
    h-5
    w-9
    shrink-0
    cursor-pointer
    items-center
    rounded-full
    border-2
    border-transparent
    shadow-sm
    transition-[background-color] duration-150 ease-in-out
    focus-visible:outline-none
    focus-visible:ring-2
    focus-visible:ring-ring
    focus-visible:ring-offset-2
    focus-visible:ring-offset-background
    disabled:cursor-not-allowed
    disabled:opacity-50
    data-[state=checked]:bg-neutral-700
    data-[state=unchecked]:bg-neutral-200
  `
)

// Styles for the SwitchPrimitives.Thumb
export const thumbStyles = cva(
  `
    pointer-events-none
    block
    h-4
    w-4
    rounded-full
    bg-neutral-0
    shadow-lg
    ring-0
    transition-transform
    data-[state=checked]:translate-x-4
    data-[state=unchecked]:translate-x-0
  `
)

export const labelStyles = cva(
  `
    text-sm
    text-neutral-700
    font-medium
    leading-none
    peer-disabled:cursor-not-allowed
    peer-disabled:opacity-70
  `
)
